/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Gallery from 'react-grid-gallery';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Breadcrumb from '../../../components/Breadcrumb';
import Sidebar from '../../../components/Sidebar/AboutUs';
import s from '../AboutUs.css';

class QualityPolicy extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    images1: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        srcset: PropTypes.array,
        caption: PropTypes.string,
        thumbnailWidth: PropTypes.number,
        thumbnailHeight: PropTypes.number,
        isSelected: PropTypes.bool,
      }),
    ).isRequired,
    images2: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        srcset: PropTypes.array,
        caption: PropTypes.string,
        thumbnailWidth: PropTypes.number,
        thumbnailHeight: PropTypes.number,
        isSelected: PropTypes.bool,
      }),
    ).isRequired,
  };

  static defaultProps = {
    images1: [
      {
        src: '/images/quality-policy/sirim-test.png',
        thumbnail: '/images/quality-policy/sirim-test.png',
        thumbnailWidth: 1028,
        thumbnailHeight: 494,
        caption: 'SIRIM Test',
        thumbnailCaption: 'SIRIM Test',
      },
      {
        src: '/images/quality-policy/internal-brick-strength-test.png',
        thumbnail: '/images/quality-policy/internal-brick-strength-test.png',
        thumbnailWidth: 1028,
        thumbnailHeight: 494,
        caption: 'Internal Brick Strength Test',
        thumbnailCaption: 'Internal Brick Strength Test',
      },
    ],
    images2: [
      {
        src:
          '/images/quality-policy/various-training-programs-to-improve-safety-and-efficiency.png',
        thumbnail:
          '/images/quality-policy/various-training-programs-to-improve-safety-and-efficiency.png',
        thumbnailWidth: 505,
        thumbnailHeight: 362,
        caption: 'Various Training Programs to improve Safety and Efficiency',
        thumbnailCaption:
          'Various Training Programs to improve Safety and Efficiency',
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = {
      images1: this.props.images1,
      images2: this.props.images2,
    };
  }

  render() {
    return (
      <div className={s.root}>
        <Breadcrumb title={this.props.title} />
        <div className={s.container}>
          <Sidebar title={this.props.title} />
          <div className={s.contents}>
            <h1>
              {this.props.title}
            </h1>
            <p>
              We are committed to providing customers with highest possible
              level of quality. In order to achieve this, we are continually
              improving processes, products and services, meeting and exceeding
              customer satisfaction at all times.
            </p>
            <div className={s.gallery}>
              <Gallery
                images={this.state.images1}
                backdropClosesModal
                enableImageSelection={false}
                rowHeight={247}
              />
            </div>
            <div className={s.gallery}>
              <Gallery
                images={this.state.images2}
                backdropClosesModal
                enableImageSelection={false}
                rowHeight={232}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(QualityPolicy);



// WEBPACK FOOTER //
// ./src/routes/about-us/quality-policy/QualityPolicy.js